import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddTemplateScheduleForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.templateSchedule_text_numberOfDays,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'numberOfDays',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateIntegerOnly, min: -30, max: 30 },
      ],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.mailTemplate_text_subject,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'mailSubject',
      validators: [],
      responsive: { xs: 12, sm: 6, md: 8 },
      required: false,
      disabled: true,
    },
  ];
};
